<template>
<div>
  <div class="contact__info">
    <div class="first-col">
      <span class="fas fa-envelope"></span>
    </div>

    <div>
      <div>
      <p class="h3">{{ company.name }}</p>

      <ul class="text-small list-unstyled">
        <li>
          <span>Adresse:</span>
          {{ company.street }}, {{ company.zip }} {{ company.city }}
        </li>

        <li>
          <span>Telefon:</span>
          <a :href="'tel:' + company.phone" class="text-normal">
              {{ company.phone }}
          </a>
        </li>

        <li>
          <span>Fax:</span>
          {{ company.fax }}
        </li>
      </ul>
      </div>
    </div>
  </div>

  <div class="contact__info">
    <div class="first-col">
      <span class="fas fa-map-marker-alt"></span>
    </div>

    <div>
      <div>
        <p class="h3">Ihr Weg zu uns</p>

        <p class="text-small">
          Vereinbaren Sie jetzt einen persönlichen Besprechungstermin. Wir freuen uns auf Sie.
        </p>

        <p>
          <a :href="'https://www.google.de/maps?daddr=' + company.street + ', ' + company.zip + '+' + company.city + '&saddr='"
            title="Route jetzt berechnen"
            target="_blank"
            class="link--arrow">
              Route jetzt berechnen
          </a>
        </p>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "ContactCompanyInfo",

  computed: {
    company() {
      return this.$yeti.company();
    }
  },

  methods: {
    onMapLoad(o) {
      o.L.marker(o.defaultCenter).addTo(o.map);
      this.mapCenter = o.defaultCenter;
    }
  }
}
</script>
